import React, { useEffect, useState } from "react";

// Donut SVG sin dependencias. value/max definen el porcentaje del arco.
// color: token CSS (ej. 'var(--esen-success)').
const DonutChart = ({
  value = 0,
  max = 10,
  size = 120,
  stroke = 12,
  color = "var(--esen-primary)",
  caption,
  display,
}) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const pct = max > 0 ? Math.min(Math.max(value / max, 0), 1) : 0;

  // Arranca en 0 y anima hasta el valor (transición CSS en stroke-dashoffset)
  const [offset, setOffset] = useState(circumference);
  useEffect(() => {
    const id = window.requestAnimationFrame(() => {
      setOffset(circumference * (1 - pct));
    });
    return () => window.cancelAnimationFrame(id);
  }, [circumference, pct]);

  return (
    <div className="esen-donut" style={{ width: size, height: size }}>
      <svg width={size} height={size} role="img" aria-label={`${caption || "Valor"}: ${value} de ${max}`}>
        <circle
          className="esen-donut-track"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={stroke}
        />
        <circle
          className="esen-donut-value"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={stroke}
          stroke={color}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="esen-donut-center">
        <span className="esen-donut-number">{display != null ? display : value}</span>
        {caption ? <span className="esen-donut-caption">{caption}</span> : null}
      </div>
    </div>
  );
};

export default DonutChart;
